/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

String.prototype.handleize = function() {
  return this.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "").normalize("NFD").replace(/[\u0300-\u036f]/g, "")
};

window.onscroll = function(e) {
  var header = document.getElementById('shopify-section-header');
  if(window.screen.availWidth <= 1007 && this.scrollY > header.offsetHeight) {
    if(this.oldScroll > this.scrollY ) {
      header.classList.remove('hide__header');
    } else {
      header.classList.add('hide__header');
    }
  }

  if(window.screen.availWidth > 1007 && window.theme.template === 'index') {
    var headerContainer = header.querySelector('header.Header');
    if(this.scrollY > 0) {
      headerContainer.classList.add('Header--minified');
    } else {
      headerContainer.classList.remove('Header--minified');
    }
    document.documentElement.style.setProperty('--header-height', document.getElementById('shopify-section-header').offsetHeight + 'px');
  }

  // print "false" if direction is down and "true" if up
  // console.log(this.oldScroll > this.scrollY);
  this.oldScroll = this.scrollY;
};

var updateImageHeight = function() {
  var productImage = document.querySelector('.ProductItem__Image');
  document.querySelectorAll('.ProductItem__IconsWrapper').forEach(function(iconsWrapper) {
    iconsWrapper.setAttribute('style','--img-height:' + (productImage.height - iconsWrapper.offsetHeight) + 'px;');
  });
}

if(document.querySelector('.CollectionInner__Products') !== null) {
  updateImageHeight();
  window.addEventListener('resize', updateImageHeight);
}

var AjaxinateConfig = {
  container: '#ProductList',
  pagination: '#Paginate',
  loadingText: '<img class="Rotate" alt="'+window.theme.shopName+'" src="'+window.theme.loaderImgUrl+'">',
  callback: function() {
    updateImageHeight();
    document.querySelectorAll('.ProductItem').forEach(function(product) {
      if(product.getAttribute('style') === null) {
        product.setAttribute('style','visibility: inherit; opacity: 1; transform: matrix(1, 0, 0, 1, 0, 0);');
      }
    });
  }
};

document.addEventListener("DOMContentLoaded",function() {
  if(document.getElementById('ProductList') === null) { return; }
  if(typeof Ajaxinate === "undefined") { return; }
  var endlessScroll = new Ajaxinate(AjaxinateConfig);
});

document.addEventListener("theme:loading:end",function() {
  if(typeof Ajaxinate === "undefined") { return; }
  var endlessScroll = new Ajaxinate(AjaxinateConfig);
});

// document.addEventListener("theme:menu:open",function() {
//   console.log('menu:open')
//   // document.querySelector('.PageOverlay').classList.add('is-visible');
// });

// document.addEventListener("theme:menu:close",function() {
//   console.log('menu:close')
//   // document.querySelector('.PageOverlay').classList.remove('is-visible');
// });

document.addEventListener("theme:popover:open",function() {
  document.querySelector('.PageOverlay').classList.add('is-visible','white');
});

document.addEventListener("theme:popover:close",function() {
  document.querySelector('.PageOverlay').classList.remove('is-visible','white');
});

(document.querySelector('[data-action="open-topbar"]') !== null) && document.querySelector('[data-action="open-topbar"]').addEventListener('click',function(e){
  var targetId = e.target.getAttribute('data-topbar-id');
  var targetNode = document.getElementById(targetId);
  var ariaHidden = targetNode.getAttribute('aria-hidden');

  targetNode.setAttribute('aria-hidden', (ariaHidden === 'false' ) ? 'true' : 'false');
});

document.querySelectorAll('.Topbar .Link').forEach(function(el){
  el.addEventListener('click', function() {
    setTimeout(function() {
      document.getElementById('TopbarSubmit').click();
    }, 250);
  });
});

if(document.querySelector('.ColorSwatch[data-tooltip]') !== null) {
  document.querySelectorAll('.ColorSwatch[data-tooltip]').forEach(function(el){
    el.addEventListener('click', function() {
  
      var _this = this;
      var targetSlideshowId = '#slideshow-' + _this.getAttribute('data-tooltip').handleize();
  
      var targetSlideshow = (document.querySelector(targetSlideshowId))
        ? document.querySelector(targetSlideshowId)
        : document.querySelector('#slideshow-default');
  
      (targetSlideshow !== null) && targetSlideshow.removeAttribute('hidden');
  
      setTimeout(function(){
        if(targetSlideshow !== null && !targetSlideshow.classList.contains('flickity-enabled')) {
          var flick = new Flickity(targetSlideshow, JSON.parse(targetSlideshow.getAttribute('data-flickity-config')));
        }
        document.querySelectorAll('.Product__Slideshow').forEach(function(productSlideshow){
          if(targetSlideshow === productSlideshow) { return; }
          productSlideshow.setAttribute('hidden','');
        });
      },100);
    });
  });
}

(document.querySelector('[data-read-more]') != null) && document.querySelector('[data-read-more]').addEventListener('click',function(){
  this.style.display = 'none';
  document.querySelector('[data-desc]').classList.add('open');
  document.querySelector('[data-read-less]').style.display = '';
  document.querySelectorAll('[data-desc] p').forEach(function(p){
    p.style.display = 'block';
  });
});

(document.querySelector('[data-read-less]') != null) && document.querySelector('[data-read-less]').addEventListener('click',function(){
  this.style.display = 'none';
  document.querySelector('[data-desc]').classList.remove('open');
  document.querySelector('[data-read-more]').style.display = '';
  document.querySelectorAll('[data-desc] p').forEach(function(p){
    p.style.display = '';
  });
});

var tapArea, startX;
tapArea = document.querySelectorAll('.Product__SlideItem');
startX = 0;
for (var item of tapArea) {
  item.ontouchstart = function(e) {
    startX = e.touches[0].clientX;
  };
  item.ontouchmove = function(e) {
    if (Math.abs(e.touches[0].clientX - startX) > 5 && e.cancelable ) {
      e.preventDefault();
    }
  };
}
